import { useEffect } from 'react';

const BookemWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://bookings.mobiletheatre.co.za/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div data-mt-booking="ca423a96-ba06-45ef-9f32-76ee49e1f04d" />
  );
};

export default BookemWidget;